import CarouselItem from "./CarouselItem";
import Carousel from "react-material-ui-carousel";
import classes from "./Carousel.module.css";

const CarouselComponent = ({ items, styleType }) => {
  return (
    <Carousel
      // navButtonsAlwaysVisible
      navButtonsAlwaysInvisible
      stopAutoPlayOnHover
      animation="slide"
      height="100%"
      className={[classes.carouselCom, styleType === "radiusBorder" ? classes.radiusBorder : null].join(
        " "
      )}
      indicatorContainerProps={{
        style: {
          position: "absolute",
          bottom: "10px",
          zIndex: 100,
        },
      }}
    >
      {items.map((item, i) => (
        <CarouselItem key={i} item={item} />
      ))}
    </Carousel>
  );
};

export default CarouselComponent;
